import { render, staticRenderFns } from "./dr-login-sms-component.vue?vue&type=template&id=00238ab8&"
import script from "./dr-login-sms-component.vue?vue&type=script&lang=js&"
export * from "./dr-login-sms-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports